export interface User {
  id: string;
  username: string;
  raceTag: string;
  homeTrack: string;
  keycloakId: string;
  email: string;
  friends: string[];
  role: UserRole;
}

export interface FriendRequest {
  from: string;
  to: string;
  id: string;
}

export enum UserRole {
  ADMIN = "ADMIN",
  USER = "USER",
}
